import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import CreateLayout from 'layouts/CreateLayout';

import Navbar from 'components/Navbar';

import UserTabs from './UserTabs';
import theme from './theme.module.scss';

const CreateUser: FC<{ onClose?: () => void }> = ({ onClose }) => {
  return (
    <CreateLayout onClose={onClose}>
      <Navbar title="Create User" subTitle="Create a new user account" />
      <div className={theme.main}>
        <UserTabs />
        <div className={theme.content}>
          <Outlet />
        </div>
      </div>
    </CreateLayout>
  );
};

export default CreateUser;
